import {computed, makeObservable, observable} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'CurrencyModel';

export class CurrencyModel extends BaseModel {
  constructor(public type: CurrencyModel.Type) {
    super({
      id: type,
    });

    makeObservable<CurrencyModel, 'typeLc'>(this, {
      name: computed,
      sign: computed,
      type: observable,
      typeLc: computed,
    });
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  get name() {
    /**
     * @i18n_parser
     * t('shared:currency.eur')
     * t('shared:currency.gbp')
     * t('shared:currency.usd')
     */
    return i18n.t(`shared:currency.${this.typeLc}`);
  }

  get sign() {
    switch (this.typeLc) {
      case 'eur':
        return '€';
      case 'gbp':
        return '£';
      case 'usd':
        return '$';
    }
  }

  private get typeLc(): CurrencyModel.LcType {
    return this.type.toLowerCase() as CurrencyModel.LcType;
  }
}

export namespace CurrencyModel {
  export type LcType = 'eur' | 'gbp' | 'usd';

  export type Props = BaseModel.ModelToProps<CurrencyModel>;
  export type Type = LcType | UcType;

  type UcType = 'EUR' | 'GBP' | 'USD';
}
